export default __webpack_public_path__ + "static/media/Undo.8c1fd575.svg";